import { getTransArr, replaceEmptySpace } from "./utils";

export const ENABLED_COUNTRIES = [
  "AUSTRALIA",
  "HONG KONG",
  "JAPAN",
  "INDIA",
  "NEW ZEALAND",
  "SINGAPORE",
  "TAIWAN",
  "THAILAND",
  "UNITED KINGDOM",
];

export const COUNTRY_CODE_MAP = {
  AUSTRALIA: "AU",
  HONGKONG: "HK",
  INTERNATIONALEUROCARD: "EU",
  INDIA: "IN",
  JAPAN: "JP",
  NEWZEALAND: "NZ",
  NORWAY: "NO",
  SINGAPORE: "SG",
  SWEDEN: "SE",
  TAIWAN: "TW",
  THAILAND: "TH",
  UNITEDKINGDOM: "GB"
};
export const IEC_LABEL = "INTERNATIONALEUROCARD";
export const DEFAULT_LABEL = "DEFAULT";

export const INFO_FIELDS = {
  COMPANYINFO: "companyInfo",
  CORRESPONDENCEINFO: "correspondenceInfo",
};

export const COUNTRY_NAME = {
  AUSTRALIA: "AUSTRALIA",
  HONGKONG: "HONG KONG",
  INTERNATIONALEUROCARD: "INTERNATIONAL EURO CARD",
  INDIA: "INDIA",
  NEWZEALAND: "NEW ZEALAND",
  IEC: "INTERNATIONAL EURO CARD",
  NORWAY: "NORWAY",
  SINGAPORE: "SINGAPORE",
  SWEDEN: "SWEDEN",
  TAIWAN: "TAIWAN",
  THAILAND: "THAILAND",
  UNITEDKINGDOM: "UNITED KINGDOM",
  OTHERCOUNTRIES: "OTHER COUNTRIES",
  JAPAN: "JAPAN",
};

export const PA_SCREENING_COUNTRIES = [
  COUNTRY_NAME.SWEDEN,
  COUNTRY_NAME.NORWAY,
  COUNTRY_NAME.AUSTRALIA,
  COUNTRY_NAME.NEWZEALAND,
  COUNTRY_NAME.SINGAPORE,
  COUNTRY_NAME.INTERNATIONALEUROCARD,
];

export const COUNTRIES_WITH_CITY_FIELD = (t) => [
  t(`access.SWEDEN`),
  t(`access.NORWAY`),
];

export const MODIFY_PIN_RETAINING_COUNTRIES = (t) => [
  t(`access.${replaceEmptySpace(COUNTRY_NAME.UNITEDKINGDOM)}`),
  t(`access.${COUNTRY_NAME.SWEDEN}`),
  t(`access.${COUNTRY_NAME.NORWAY}`),
  t(`access.${replaceEmptySpace(COUNTRY_NAME.INTERNATIONALEUROCARD)}`),
];

export const PERSONAL_ID_HELPER_TEXT_MAP = (t) => ({
  [t(`access.${COUNTRY_NAME.SWEDEN}`)]: "newuser.personalIdHelperTextSweden",
  [t(`access.${COUNTRY_NAME.NORWAY}`)]: "newuser.personalIdHelperTextNorway",
});


export const COUNTRY_WITH_DISCLAIMER = ["AUSTRALIA", "NEW ZEALAND"];

export const COUNTRY_INFO_TEXT = {
  SINGAPORE: "newuser.singaporeCountryInfo",
};

export const COUNTRY_CODE_PREFIX = {
  AUSTRALIA: "006000000",
  HONGKONG: "009000000",
  INDIA: "012000000",
  INTERNATIONALEUROCARD: "056",
  NEWZEALAND: "007000000",
  NORWAY: "030",
  SINGAPORE: "011000000",
  SWEDEN: "034",
  THAILAND: "015000000",
  TAIWAN: "039000000",
  UNITEDKINGDOM: "036",
};

export const APAC_COUNTRIES = [
  "AUSTRALIA",
  "HONG KONG",
  "JAPAN",
  "INDIA",
  "NEW ZEALAND",
  "SINGAPORE",
  "TAIWAN",
  "THAILAND",
];
export const SWEDEN_NORWAY = [COUNTRY_NAME.SWEDEN, COUNTRY_NAME.NORWAY];
export const EUROZONE_COUNTRIES = [
  COUNTRY_NAME.SWEDEN,
  COUNTRY_NAME.NORWAY,
  COUNTRY_NAME.INTERNATIONALEUROCARD,
];
export const UK_COUNTRIES = ["UNITED KINGDOM"];

export const EURO_COUNTRIES = new Set([
  "INTERNATIONAL EURO CARD",
  "NORWAY",
  "SWEDEN",
]);

export const MODIFY_ACCESS_OPTIONAL_COUNTRIES = (t) =>
    new Set([
      t(`access.${COUNTRY_NAME.SWEDEN}`),
      t(`access.${COUNTRY_NAME.NORWAY}`),
      t(`access.${IEC_LABEL}`),
    ]);

export const GENDER_COUNTRY_EXCLUDE_LIST = new Set([COUNTRY_NAME.SWEDEN]);
export const PA_PERMISSION_ONLINE = new Set(["paPermissionOnline"]);
export const EXISTING_PA = "1";
export const NEW_PA = "2";
export const JOURNEY_TYPE = {
  ADD: "ADD",
  MODIFY: "MODIFY",
};

const DOC_MANDATORY_COUNTRIES = {
  [COUNTRY_NAME.AUSTRALIA]: {
    journeys: new Set([JOURNEY_TYPE.ADD, JOURNEY_TYPE.MODIFY]),
  },
  [COUNTRY_NAME.NEWZEALAND]: {
    journeys: new Set([JOURNEY_TYPE.ADD, JOURNEY_TYPE.MODIFY]),
  },
  [COUNTRY_NAME.SINGAPORE]: {
    journeys: new Set([JOURNEY_TYPE.ADD]),
    selfEnrollOptions: new Set([NEW_PA]),
  },
};

export const getDocMandatoryCountries = (translate, journeyType, selfenroll) => {
  const docMandatoryCountries = Object.entries(DOC_MANDATORY_COUNTRIES)
    .filter(([, config]) =>
      config.journeys.has(journeyType) &&
      (!config.selfEnrollOptions || config.selfEnrollOptions.has(selfenroll))
    )
    .map(([country]) => country);
  return getTransArr(docMandatoryCountries, translate);
};

export const getVerificationWordMandatoryCountries = (translate) => {
  const verificationWordMandatoryCountries = [
    COUNTRY_NAME.INDIA,
    COUNTRY_NAME.HONGKONG,
    COUNTRY_NAME.SINGAPORE,
    COUNTRY_NAME.THAILAND,
    COUNTRY_NAME.TAIWAN,
  ];
  return getTransArr(verificationWordMandatoryCountries, translate);
};

export const SWEDEN_CODES = ["sweden", "se"];
export const NORWAY_CODES = ["norway", "no"];
export const IEC_CODES = ["international euro card", "eu"];

export const REGEX = {
  WHITESPACE: /\s+/g,
  LETTER_SPACE_HYPHEN: /^[a-zA-Z -]*$/,
  FREE_FORM: /^.*$/,
  NUMBER: /^[0-9]+$/,
  NUMBER_HYPHEN: /^[0-9-]+$/,
  ALPHANUMERIC_HYPHEN: /^[A-Z0-9]+(?:-[A-Z0-9]+)*$/,
  EMAIL:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,}$/,
  TWO_DIGIT_NUMBER: /^[0-9]{1,2}$/,
  FOUR_DIGIT_NUMBER: /^\d{4}$/,
  PERSONAL_ID_NUMBER: /^\d{6}-\d{5}$/,
  DDMMYYYY: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
  POSITION_ALPHA: /^(?!_\s)[a-zA-Z_\s]*$/,
  NAME_ALPHA: /^[a-zA-Z]*$/,
  PHONE: /^[0-9+-]*$/,
  USER_ID: /^[a-zA-Z0-9_]*$/,
  ALPHANUMERIC: /^[a-zA-Z0-9]*$/,
  POSTAL_CODE: /^[0-9\s-]+$/,
  COUNTRY_RESIDENCE: /^[a-zA-Z\s-]+$/,
};

export const TITLE_OPTIONS = ["Mr", "Mrs", "Ms", "Miss"];

export const PA_COUNTRIES = [
  "USA",
  "Canada",
  "Argentina",
  "Mexico",
  "GDC",
  "Australia",
  "Hong Kong",
  "Singapore",
  "India",
  "New Zealand",
  "Japan",
  "Thailand",
  "Taiwan",
  "United Kingdom",
  "France",
  "Italy",
  "Spain",
  "Austria",
  "Netherlands",
  "IEC",
  "Czech Rep",
  "Hungary",
  "Poland",
  "Germany",
  "Belgium",
  "Denmark",
  "Sweden",
  "Norway",
  "Finland",
];

export const COUNTRY = {
  INDIA: "India",
};

export const GET_PEP_POSITION_LIST = (t) => [
  {
    value: "dropdown_menu",
    label: t("newuser.politicallyExposedDropdown"),
  },
  {
    value: "head_of_state",
    label: t("newuser.headOfState"),
  },
  {
    value: "national_assembly_member",
    label: t("newuser.nationalAssemblyMember"),
  },
  {
    value: "governing_body_member",
    label: t("newuser.governingBodyMember"),
  },
  {
    value: "high_court_member",
    label: t("newuser.highCourtMember"),
  },
  {
    value: "board_of_auditors_member",
    label: t("newuser.boardOfAuditorsMember"),
  },
  {
    value: "ambassador",
    label: t("newuser.ambassador"),
  },
  {
    value: "member_of_the_administrative",
    label: t("newuser.memberOfTheAdministrative"),
  },
  {
    value: "director",
    label: t("newuser.director"),
  },
];

export const TYPE_OF_DOCUMENT = ["PASSPORT", "NATIONAL ID"];

export const functionListSwedenNorwayIEC = [
  {
    function: "products.functname1",
    docName: "user2_access1_function1.pdf",
  },
  {
    function: "ukFunction.function2",
    docName: "user2_access1_function1.pdf",
  },
  {
    function: "ukFunction.function7",
    docName: "",
  },
  {
    function: "ukFunction.function8",
    docName: "",
  },
  {
    function: "ukFunction.function9",
    docName: "",
  },
];
export const IEC_DETAILS = [
  {
    function: "products.functname1",
    docName: "user2_access1_function1.pdf",
  },
  {
    function: "ukFunction.function2",
    docName: "user2_access1_function1.pdf",
  },
  {
    function: "ukFunction.function7",
    docName: "",
  },
  {
    function: "ukFunction.function8",
    docName: "",
  },
  {
    function: "ukFunction.function9",
    docName: "",
  },
  {
    function: "ukFunction.function4",
    docName: "",
  },
  {
    function: "ukFunction.function5",
    docName: "",
  },
];

export const functionList = [
  {
    function: "products.functname1",
    docName: "user2_access1_function1.pdf",
  },
  {
    function: "ukFunction.function2",
    docName: "user2_access1_function1.pdf",
  },
  {
    function: "ukFunction.function3",
    docName: "user2_access1_function1.pdf",
  },
  {
    function: "ukFunction.function4",
    docName: "",
  },
  {
    function: "ukFunction.function5",
    docName: "",
  },
  {
    function: "ukFunction.function6",
    docName: "",
  },
  {
    function: "ukFunction.function7",
    docName: "",
  },
  {
    function: "ukFunction.function8",
    docName: "",
  },
  {
    function: "ukFunction.function9",
    docName: "",
  },
  {
    function: "ukFunction.function10",
    docName: "",
  },
  {
    function: "ukFunction.function11",
    docName: "",
  },
  {
    function: "ukFunction.function12",
    docName: "",
  },
];

export const DSG_INDIA = "Data Support Group - India";
export const DSG_GRC = "GRC";
export const ACT_CAN = "ACT Canada";
export const APPLICATION_JSON = "application/json;charset=utf-8";
export const CREATE = "Create";
export const MODIFY = "Modify";
export const GENDER = "gender";
export const MALE = "male";
export const FEMALE = "female";
export const yes = "yes";
export const no = "no";
export const JAPAN_NAME_LIST = ["JAPAN", "日本"];
export const VERIFY_CAPTCHA = "you must verify the captcha";
export const CAPTCHA_FAILED = "Captcha verification failed";
export const DAY_MONTH_BIRTH = "Day of birth and Month of birth";
export const EN = "en";
export const JAP = "jap";
export const DELETE_USER_ERROR = "Error calling deleteuser:";
export const NORWAY = "Norway";
export const SWEDEN = "Sweden";
export const TRUE = "true";
export const AGREE = "agree";

export const USER_FIELDS = [
  "language",
  "day",
  "month",
  "year",
  "selfenroll",
  "files",
  "access",
  "showCheckBox",
  "modifyCheckBox",
  "showOtherTitle",
  "eeaCheckbox",
];


export const AUTHORIZED_POSITIONS = {
  EN: ["Program Administrator", "Authorized Signatory"],
  OTHER: [
    "Program Administrator",
    "Authorized Signatory",
    "Decision Maker",
    "Authorised Signatory",
    "Authorising Officer",
  ],
};

export const APPROVER_OPTIONS = {
  NORWAY: [1, 2, 3],
  SWEDEN: [1, 2],
  DEFAULT: [1],
};

export const APPROVER_COUNT = {
  [COUNTRY_NAME.NORWAY]: 3,
  [COUNTRY_NAME.SWEDEN]: 2,
};

export const APPROVER_LIST_MAP = {
  [COUNTRY_NAME.NORWAY]: APPROVER_OPTIONS.NORWAY,
  [COUNTRY_NAME.SWEDEN]: APPROVER_OPTIONS.SWEDEN,
};

export const AUTH_SIGNATORY_VALIDATION_FIELDS = {
  fName: REGEX.LETTER_SPACE_HYPHEN,
  lName: REGEX.LETTER_SPACE_HYPHEN,
  position: (value) => !value,
  emailId: REGEX.EMAIL,
  phoneNumber: REGEX.NUMBER,
};

export const COMPANYINFO_VALIDATION_FIELDS = {
  bussRegName: REGEX.LETTER_SPACE_HYPHEN,
  bussRegAddress: REGEX.FREE_FORM,
  bussRegPostcode: REGEX.NUMBER,
  bussRegCity: REGEX.LETTER_SPACE_HYPHEN,
  bussRegCountry: REGEX.LETTER_SPACE_HYPHEN,
  organisationNumber: REGEX.NUMBER,
};

export const MODAL_COUNTRY_MAP = {
  NORWAY: "termsConditionModalNorway",
  SWEDEN: "termsConditionModalSweden",
  INTERNATIONALEUROCARD: "termsConditionModal",
  UNITEDKINGDOM: "termsConditionModalUK",
  OTHERCOUNTRIES: "termsConditionModalOtherCountries",
  JAPAN: "termsConditionModalJapan",
};

export const TERMS_CONDITIONS_LABEL = {
  NORWAY: {
    id: "NORWAY",
    checkboxLabel: "termsConditionModalNorway.termsAndConditions",
    header: "termsConditionModalNorway.tcHeader",
    title: "termsConditionModalNorway.title",
  },
  SWEDEN: {
    id: "SWEDEN",
    checkboxLabel: "termsConditionModalSweden.termsAndConditions",
    header: "termsConditionModalSweden.tcHeader",
    title: "termsConditionModalSweden.title",
  },
  INTERNATIONALEUROCARD: {
    id: "INTERNATIONAL EURO CARD",
    checkboxLabel: "termsConditionModal.termsCondition",
    header: "termsConditionModal.header",
    title: "termsConditionModal.title",
  },
  UNITEDKINGDOM: {
    id: "UNITEDKINGDOM",
    checkboxLabel: "termsConditionModalUK.termsAndConditions",
    header: "termsConditionModalUK.tcHeader",
    title: "termsConditionModalUK.title",
  },
  OTHERCOUNTRIES: {
    id: "OTHERCOUNTRIES",
    checkboxLabel: "modal.termsandconditions",
    header: "modal.termsandcondition_header",
    title: "modal.title",
  },
  JAPAN: {
    id: "JAPAN",
    checkboxLabel: "modal_japan.termsandconditions",
    header: "modal_japan.termsandcondition_header",
    title: "modal_japan.title",
  },
};

export const UPLOAD_MESSAGES = {
  INVALID_PDF: 'Please Upload a valid PDF',
  INVALID_SIZE: 'File size is more than 5MB,Please upload a file with less size',
  INVALID_TYPE: 'File type is not valid',
  NO_FILE: 'No file provided',
  FILE_READER_ERROR: 'FileReader error',
};

export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 5242880,
  ALLOWED_TYPE_REGEX: /(jpg|png|jpeg|pdf|gif|tiff)/i,
  PDF_VALIDATION_ENDPOINT: '/validatePdf',
};

export const BIRTH_YEAR_REQUIRED_MARKETS = (t) =>
    new Set([
        t(`access.${COUNTRY_NAME.SINGAPORE}`),
        t(`access.${COUNTRY_NAME.JAPAN}`),
        t(`access.${COUNTRY_NAME.NEWZEALAND.replace(" ","")}`)
    ])
